<template>
  <div style="text-align: center">
    <!-- 头部 -->
    <header class="header flex-between">
      <img src="../static/img/home/logo.png" />
      <!-- <div class="header-title">{{ $t('langType.title') }}</div> -->
      <div class="header-right flex-between">
        <ul class="flex-start">
          <!-- <li name="tw">{{ $t('langType.tw') }}</li>
          <li name="cn">{{ $t('langType.cn') }}</li>
                    <li name="en" style="padding-right:0rem!important;border-right: 0rem;">{{ $t('langType.en') }}</li>-->
          <li name="tw" @click="changeLang">繁體</li>
          <!-- <li name="cn"><a href="http://chanxue.m.langqiyun.cn" target="_blank" >简体</a></li> -->
          <li name="cn">简体</li>
          <li
            name="en"
            style="padding-right: 0rem !important; border-right: 0rem"
          >
            <a href="http://www.eg-anhsiangchan.url.tw/">English</a>
          </li>
        </ul>
      </div>
    </header>
    <!-- 首页轮播图(单图) -->
    <div class="swiper">
      <img :src="home.head_banner" alt />
      <!-- <swiper :options="swiperOption" class="swiper">
                <swiper-slide v-for="(item, index) in swiperList" :key="index">
                    <img :src="item.src" :alt="item.alt" />
                    <img src="../static/img/home/banner.png" alt />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>-->
    </div>
    <!-- 轮播下面的文字展示 -->
    <div class="bannerMsg">
      <div class="bannerMsgText">{{ $t("bannerText") }}</div>
    </div>
    <!-- 具体内容 -->
    <div class="container">
      <!-- 导航 -->
      <NavLink></NavLink>
      <!-- 新聞列表 -->

      <news-list :study="study" :activity="activity"></news-list>

      <!-- 图片 -->
      <div class="bottomPic">
        <img :src="home.foot_banner" />
        <div class="line"></div>
      </div>
    </div>
    <div
      :class="index % 2 == 0 ? 'newsList' : 'newsList1'"
      v-for="(item, index) in news"
      @click="linkToDetail(item)"
      :key="index"
    >
      <div class="newslist_text">{{ item.news_title }}</div>
    </div>
    <footer>
      <!-- 联系方式 -->
      <div class="footer">
        <h3 class="color38 fz8">{{ $t("footer").title }}</h3>
        <p>{{ $t("footer").chanxue }}</p>
        <p style="display: block">{{ $t("footer").tel }} {{ home.tel }}</p>
        <p>{{ $t("footer").address }}{{ home.address }}</p>
        <p>{{ $t("footer").number }}{{ home.address_num }}</p>
        <!-- <p>{{ $t("footer").email }}{{ home.email }}</p> -->
        <p>{{ $t("footer").email }}geng_nv@163.com</p>
      </div>
      <!-- 导航 -->
      <NavLink></NavLink>
        <!-- <div
        style="
          border-top: 1px solid #666666;
          text-align: center;
          height: 40px;
          line-height: 40px;
        "
      >
        <a
          href="http://www.beian.miit.gov.cn/"
          style="text-decoration: none; color: rgb(136 136 136);font-size: 0.85rem;"
        >
          京ICP备05043713号</a
        >
      </div> -->
    </footer>
  </div>
</template>

<script>
import { getHome } from "../api/apis";

import NewsList from "../components/News.vue";
import NavLink from "../components/NavLink.vue";
export default {
  name: "home",
  components: {
    NewsList,
    NavLink,
  },
  data() {
    return {
      home: {}, //首页基本信息
      study: [], //最新闻讯信息
      activity: [], //	最新活动信息
      // swiperOption: {
      //     loop: true, // 循环模式选项
      //     autoplay: {
      //         delay: 5000
      //     },
      //     pagination: {
      //         el: ".swiper-pagination"
      //     }
      // },
      // swiperList: [
      //     {
      //         src: require("../static/img/home/banner1.png"),
      //         alt: "banner1"
      //     },
      //     {
      //         src: require("../static/img/home/banner1.png"),
      //         alt: "banner2"
      //     },
      //     {
      //         src: require("../static/img/home/banner1.png"),
      //         alt: "banner3"
      //     }
      // ],
      newsList: [{}, {}],
      news:[],
    };
  },
  methods: {
    changeLang(){
      localStorage.clear();
      window.location.href = window.location.origin+'/m/#/';
    },
    // changeWord(e) {
    //     let name = e.target.getAttribute("name");
    //     switch (name) {
    //         case "cn":
    //         this.$i18n.locale = "zh-CN";
    //             localStorage.setItem('language',1);

    //             break;
    //         case "tw":
    //             this.$i18n.locale = "zh-TW";
    //              localStorage.setItem('language',2);

    //             break;
    //         case "en":
    //             this.$i18n.locale = "en-US";
    //             localStorage.setItem('language',3);
    //             break;
    //     }
    //     //切换语言后，重新请求首页数据
    //     this.getHomeInfo();
    //     // window.location.reload();
    // },
    linkBrief() {
      this.$router.push({
        path: "/brief",
      });
    },
    linkCase() {
      this.$router.push({
        path: "/case",
      });
    },
    linkToDetail(item) {
        console.log(item.news_title)
    //     console.log('https://chanxue.m.langqiyun.cn' + `/articleDetail?name=${item}&id=` + item.id)
      window.open(
       window.location.origin+'/m_cn/#' + `/articleDetail?name=information&id=` + item.id,'_self'
      );
    },
    getHomeInfo() {
      getHome().then((res) => {
        this.home = res.home;
        this.study = res.study;
        this.activity = res.activity;
        this.news = res.new
        console.log(this.news,'news')
      });
    },
  },
  created() {
    //清理localStory里面的nowIndex
    localStorage.setItem("nowIndex", "");

    //获取home页面的数据
    this.getHomeInfo();
  },
  // mounted() {
  //     console.log('111');
  //     getHome().then(res => {
  //       console.log('111',res);
  //     })
  // }
};
</script>

<style scoped>
.newsList {
  width: 100%;
  line-height: 1.5rem;
  font-size: 0.85rem;
  text-align: left;
}
.newslist_text {
  margin-left: 15px;
}
.newsList1 {
  width: 100%;
  line-height: 1.5rem;
  font-size: 0.85rem;
  text-align: left;
  background: #f4f3ee;
}
img {
  width: 100%;
}

.header {
  height: 2.35rem;
  /* line-height: 2.35rem; */
  padding-left: 0.64rem;
  padding-right: 0.64rem;
  position: relative;
}

.header img {
  width: 4.5rem;
  /* width: 3.7rem; */
  /* height: 1.49rem; */
}
.header-title {
  position: absolute;
  width: 5.6rem;
  height: 1.07rem;
  line-height: 1.07rem;
  text-align: center;
  font-size: 0.8rem;
  left: 50%;
  top: 50%;
  margin-top: -0.53rem;
  margin-left: -2.8rem;
}
.header-right {
  /* width: 6.8rem; */
  width: 8rem;
  font-size: 0.8rem;
}

.header-right ul {
  width: 8rem;
  color: #047bcd;
}
.header-right ul a {
  text-decoration: none;
  color: #047bcd;
}

.header-right ul li {
  /* width: 2.34rem; */
  /* display: inline-block; */
  /* margin: 0rem 0.6rem; */
  font-size: 0.85rem; /*16px */
  padding: 0rem 0.3rem;
  height: 0.85rem;
  text-align: center;
  border-right: 1px solid #047bcd;
}

.swiper {
  width: 100%;
  color: #000;
  font-size: 0.61rem;
  /* height: 15.63rem; */
}

.swiper img {
  width: 100%;
}

.bannerMsg {
  margin-top: -0.16rem; /*纠正尺寸 */
  background-image: url("../static/img/home/bannerbg.png");
  background-size: 100% 1.28rem;
  background-repeat: no-repeat;
  height: 1.28rem;
  line-height: 1.28rem;
  white-space: nowrap;
  color: #f83b0bff;
  overflow: hidden;
}
.bannerMsgText {
  animation: 20s wordsLoop linear infinite normal;
}
@keyframes wordsLoop {
  0% {
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}

.container {
  background-color: #f5f5f5;
  /* padding-top: 0.53rem; */
}

.bottomPic {
  background-color: #fff;
  width: 100%;
  height: 9.07rem;
  padding-top: 1.92rem;
}
.line {
  margin-top: -0.2rem;
  width: 100%;
  height: 0.53rem;
  background-color: #f5f5f5;
}
.footer {
  text-align: left;
  padding-left: 0.64rem;
  padding-top: 1rem;
  padding-bottom: 0.6rem;
}
.footer p,
.footer h3 {
  color: #333;
  line-height: 1.2rem;
}
.footer h3 {
  margin-bottom: 5px;
}
</style>